import React from 'react';
import styled from 'styled-components';
import { backYouTheme } from '../../../../theme';
import { useTranslation } from 'react-i18next';

const Badge = styled.span`
  display: inline-block;

  .badge-status {
    margin: 0;
    padding: 0.375rem 0.75rem;
    font-size: 1.05rem;
    line-height: 1.5;
    background-color: rgba(0, 71, 83, 0.1);
    border: 2px solid;
    border-color: rgba(0, 71, 83, 0.5);
    border-radius: 50px;
    -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    -ms-border-radius: 50px;
    -o-border-radius: 50px;

    i {
      font-size: 1rem;
      margin-right: 8px;
    }
  }

  .badge-status-red {
    i{
      color: ${backYouTheme.status.red};      
    }
  }
  .badge-status-green {
    i{
      color: ${backYouTheme.status.green};      
    }
  }

  .badge-status-blue {
    i{
      color: ${backYouTheme.status.blue};     
    }
  }

  .badge-status-dark-blue {
    i{
      color: ${backYouTheme.status.darkBlue};    
    }
  }

  .badge-status-orange {
    i{
      color: ${backYouTheme.status.orange};    
    }
  }

  .badge-status-gray {
    i{
      color: ${backYouTheme.status.gray};  
    }
  }
`;

export default function BadgeStatus(props) {

	const {
		badge,
		linkProps,
		autoTrad = false
	} = props;
	
	const { t: gctrad } = useTranslation();

	let badgeElement = (badge &&
		<Badge>
			<span className={"badge badge-status d-flex align-items-center font-weight-bold " + badge.labelColor + "  badge-status-" + badge.iconColor}>
				<i className={badge.icon}></i>
				{autoTrad ? gctrad(badge.label) : badge.label}
				{badge.complement != '' && <span className="d-inline-block ml-2 mini font-weight-normal">{badge.complement}</span>}
			</span>
		</Badge>
	)

	return (
		<>
			{linkProps ? (
				<a {...linkProps}>
					{badgeElement}
				</a>
			) : badgeElement}
		</>
	);

}
